export default {
  accepted_message: "ベットが受け付けられました。",
  waiting_message: "ベットが保留中です。",
  login: "続行するにはログインしてください...",
  password_rule: "* パスワードは大文字と小文字を区別し、6〜10文字の長さでなければなりません。",
  nickname_rule: "* 表示およびログインのためにニックネームを設定できます（アルファベットまたは数字6〜15文字）。このニックネームは一度しか設定できません。一度設定すると変更やキャンセルはできません。",
  change_password_succeed: "パスワードの変更が成功しました。",
  add_secondary_succeed: "ニックネームの設定が成功しました。",
  succeed: "アクションが正常に完了しました！",
  failed: "アクションを完了できませんでした！",
  no_information_available: "情報が利用できません。",
  select_display_language: "デフォルトの表示言語を選択してください。",
  select_odds_type: "デフォルトのオッズタイプ表示を選択してください。",
  select_page_type: "今日とアーリーマーケットページに表示するデフォルトのページタイプを選択してください。",
  select_show_score_map: "ベットを行う際に自動的にスコアマップを表示するようにシステムを有効にします。",
  select_default_event_sorting: "デフォルトのイベントソート表示を選択してください。",
  select_market_type: "ご希望のマーケットを選択してください。",
  select_page_size: "デフォルトのページサイズを選択してください。",
  change_sports_menu_order: "スポーツメニューの順番を変更するには、スポーツをドラッグしてください。",
  view_outstanding_bets_in_bet_list: "未処理のベットの処理には時間がかかる場合があります。最新の未処理のベットを表示するには、ベットリストに移動してください。",
  time_display_in_gmt_plus_8: "上記の時間はGMT+8で表示されています。",
  select_default_stake: "カスタマイズされた賭け金と最後のベット賭け金を自動的に入力するようにシステムを有効にします。",
  bet_empty: "ベットスリップが空です。ベット選択を行うにはテーブル内のオッズをクリックしてください。",
  no_event: "現在利用可能な試合やゲームはありません。その他のスポーツイベントやゲームを訪れるか、後でお越しください。",
  no_bets: "進行中のベットはありません",
  no_waiting: "保留中のベットはありません",
  no_void: "無効なベットはありません",
  odds_changed: "オッズが変更されました。",
  confirmation: "このベットを行うことを確認しますか？",
  olderversion: "古いバージョンが検出されました。更新するにはOKをクリックするか、Ctrl-F5を押してください。",
  gmt8: "上記の時間はGMT+8で表示されています。",
  no_betting_market: "ベッティングマーケットがありません",
  note_1: "未処理のベットの処理には時間がかかる場合があります。最新の未処理のベットを表示するには、マイベットに移動してください。",
  match_not_started: "試合はまだ開始されていません",

  banner1a: "スポーツを選ぶ",
  banner1b: "ゲームに参加する",
  banner1c: "90以上のスポーツと数千のライブ試合から選べる、終わりなき興奮。最高のオッズとトップスポーツピックで、勝利のチャンスをお見逃しなく。",
  banner2a: "サイコロを振る",
  banner2b: "ジャックポットを当てる",
  banner2c: "豪華なスイートでのリッチで没入感のあるカジノゲーム体験を楽しみながら、勝利を手に入れましょう。お好きなカジノゲームをプレイし、どこにいてもライブディーラーとの質の高いインタラクションをお楽しみください。",
  banner3a: "最高のゲーム体験",
  banner3b: "革命的な体験",
  banner3c: "広範なゲームのセレクションをお楽しみください。今すぐその一端を味わってください。",
  banner4a: "オリンピック競技大会",
  banner4b: "東京2020",
  banner4c: "2020年夏季オリンピック、正式には第32回オリンピック競技大会、通称東京2020は、2021年7月23日から8月8日まで東京で開催される国際的なマルチスポーツイベントです。",
  banner4d: "EURO CUP 2020を再びお届けします！",
  banner5a: "ライブスポーツ＆ゲームハイライト",
  banner5aa: "リアルタイムでコミュニティにアクセス",
  banner5b: "最高の無料ライブテレビとハイライトをウェブやモバイルデバイスで視聴しましょう。",
  banner5c: "最新のスポーツスコアをいつでも、どこでも取得できます。",

  banner6a: "E-ファイティング",
  banner6b: "最高の格闘ゲームをプレイ",
  banner6c: "お気に入りのキャラクターを集め、競技戦に参加し、戦場に入り、戦いを感じましょう！プレイすればするほど、勝利が近づきます！",

  banner7a: "新しいeスポーツインターフェース",
  banner7b: "全く新しい体験",
  banner7c: "広範なeスポーツマーケット、業界をリードするベッティング体験。",
  banner7d: "人気のある大規模マルチプレイヤー、無敵のオッズ＆スピーディーな決済。",
  
  banner8a: "V-ゲーム",
  banner8b: "ゲームをプレイして、新しい勝利の形を体験しましょう。",
  banner8c: "全く新しい勝利のレベルを体験してください。",
  banner8d: "競技から格闘まで、様々なゲームに没頭し、数時間楽しませてくれる新しいジャンルを探検してください。",

  bannersb: "国内外のあらゆるスポーツ競技に賭けられる無限のスリルと興奮をお楽しみください。私たちと一緒にいれば、常に最高のオッズを手に入れられます。",
  bannersl: "現実から離れ、現実に忠実に再現された鮮やかなバーチャルゲームで自分の幻想を体験してください。きっと夢中になります。",
  bannerlc: "どのカジノスイートにも入り、お気に入りのクラシックカジノゲームに没頭し、豪華なライブディーラーとのインタラクティブな体験を楽しんでください。",

  banner10a: "素晴らしい時間をお過ごしください",
  banner10b: "轟くドラムのリズムに合わせて漕ぎながら！",

  banner11a: "FIFAワールドカップ カタール2022 世界最大のナショナルチームトーナメント",
  banner11b: "ワールドカップ2022は2022年11月20日から12月18日までカタールで開催されます",
  banner11c: "カタールを含む32チームがこの大会に参加する予定であり、中東で初めて開催されるサッカー最大のイベントです。",

  banner13a: "1つのチーム、1つの夢、サッカートーナメントのチャンピオンになるために",
  banner13b: "スキル、戦略、情熱の究極のショーに備えましょう。市内全域から集まったチームが年次サッカートーナメントで激突します。スリリングな試合とノックアウトラウンドで、フィールド上では何でも起こり得ます。楽しい1日を過ごし、素晴らしいゲームの興奮を体験してください！",

  banner15a: "栄光ある祝福をお祝いしましょう！",
  banner15b: "ソンクラーン祭り2023おめでとう",
  banner15c: "過去に勝ったか負けたかは重要ではありません。大切なのは諦めずに前進し続けることです。Wbetはあなたとあなたの愛する人たちに、2023年のソンクラーン祭りが素晴らしいものとなるようお祈りしています。サワディー・ピー・マイ!!!",

  banner16a: "あなたとご家族に祝福されたハリラヤ・プアサをお祈りいたします！",
  // banner16b: "Happy Songkran Festival 2023",

  join_us1: "この世界をあなたのものにしましょう",
  join_us2: "24時間いつでもアクセスできるアクションと多彩な製品ラインナップで、あらゆる好みに応えます。さらに、クールなボーナス、継続的なプロモーション、そして効率的な支払いが、最高のゲーミング体験をお届けします。今すぐサインアップして、第一歩を踏み出しましょう。簡単で、すぐに始められます。",
  join_us3: "今すぐ参加",

  icon1a: "モバイルに最適化",
  icon1b: "私たちのゲームは、人気のあるモバイルプラットフォームでアクセス可能なので、お気に入りのデバイスで外出先でもゲームが楽しめます",
  icon2a: "高度なセキュリティとサポート",
  icon2b: "完全に保護されたウェブサイトで、プライバシーと個人情報を安全に守りながら、安心して私たちのゲームを楽しんで取引してください",
  icon3a: "没入型体験",
  icon3b: "贅沢で直感的かつインタラクティブな体験を提供する、厳選されたプレミアム製品を用意しています",
  icon4a: "カスタマーサポート",
  icon4b: "お客様の満足が私たちの最優先事項です。フィードバックやお問い合わせがあれば、お知らせいただき、より良いサービスを提供できるよう努めます",
  footer1a: "未成年者のギャンブル",
  footer1b: "未成年者（18歳未満）のギャンブルは違法です。すべての州で未成年者によるギャンブルを禁止しています。{fvalue} は年齢確認をランダムに行い、ギャンブラーが18歳未満である場合、賞金は没収されます。© 2004-2019。{fvalue} は国際的に登録された商標（ライセンスを持つスポーツブックメーカー）です。全著作権所有。",

  contactus_title1: "カスタマーサービスのスペシャリストが、英語と中国語でのお支払いに関する質問にお答えします。",
  contactus_title2: "国際通話料がかかる場合があります。お客様の保護、情報の確認、品質保証、および規制の遵守のために、通話を記録する場合があります。",

  days: "日",
  hours: "時間",
  mins: "分",
  secs: "秒",
  ldiff_changed: "割合が変更されました",
  no_room: "利用可能な部屋はありません。他のオプションを選択してもう一度検索するか、後でもう一度お越しください。",
  people_in_this_room: "この部屋の人数",
  room_full: "この部屋は満室です",
  room_joined: "この部屋に参加しました",
  my_room: "マイルーム",
  pin_code: "例: 123456",
  no_matches: "現在利用可能な試合やゲームはありません。",
  are_you_sure: "この操作を実行してもよろしいですか？",
  accept_terms: "チェックを入れることで、上記の利用規約を読み、理解し、同意したことを確認します。",
  accept_required: "続行する前に、上記の利用規約を読み、理解し、同意してください。",
  must_accept_better_odds: "デフォルトでは、ベットの配置時により良いオッズを自動的に受け入れます。詳細は利用規約をご覧ください。",
  maintenance_notice: "現在、システムメンテナンスを実施中です。後でもう一度お試しください。",
  not_winning_prize_in_this_tournament: "このトーナメントで賞を獲得していません",
  you_did_not_join_this_room: "この部屋に参加していません",
  deduct_confirm: "これによりゲームが開始され、クレジットが差し引かれます。<br />続行してもよろしいですか？",
  over_max_match: "このリーグの試合数が選択可能な最大数を超えています。<br />リーグを展開して希望する試合を選択してください。",

  //tournament
  button_skip: "ツアーをスキップ",
  button_previous: "前へ",
  button_next: "次へ",
  button_stop: "終了",
  button_continue: "続行",
  tour_content_1: "<h6>WBETトーナメントへようこそ</h6><p>当サイトのサポーター専用のエキサイティングな新トーナメントを発表できることを嬉しく思います。</p>",
  tour_content_2: "<h6>公開ルーム</h6><p>メンバーは通常、参加料を支払って競争的なゲームプレイに参加します。</p>",
  tour_content_3: "<h6>プライベートルーム</h6><p>メンバーは、招待ピンを使用して友人と一緒にプレイするための部屋を開くことができます。</p>",
  tour_content_4: "<h6>公開無料ルーム</h6><p>特定のイベント期間中にさまざまな組織が主催する、メンバー専用の無料参加可能なルームです。</p>",
  tour_content_5: "<h6>参加可能なプレイヤー数と料金</h6><p>プレイヤー: ルームの収容人数。</p><p>参加料: ルーム提供に基づく（アカウントホルダーの通貨）。</p>",
  tour_content_6: "<h6>ルームの詳細</h6><p>ここをクリックしてルームの統計をプレビューし、ルームに参加してください。</p>",
  tour_content_7: "<h6>プールの詳細</h6><p>優勝者のための総プール賞金と検索用のユニークルームID。</p>",
  tour_content_8: "<h6>ルーム開始の詳細</h6><p>ルームのステータスと最終参加時間の表示。",
  tour_content_9: "<h6>プライベートルームの作成</h6><p>プライベートルームを作成して、ピンで参加する友人を招待してください。</p>",
  tour_content_10: "<h6>ポイントランキング</h6><p>この機能は、プレイヤーが結果を表示して追跡するためのポイントを表示するためのものです。</p>",
};
